import React, { Component } from "react";
import { profile, GET, PUT, alert } from "./CustomComponent.js";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: "",
      array_link: [],
      user_profile: profile,
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  componentDidMount = async () => {
    this.setState({ array_link: [{ name: "หน้าหลัก", link: "/dashboard", show: false, menu: [] },...this.filterMenu(this.state.user_profile).map((e) => ({ ...e, show: JSON.stringify(e).includes(window.location.pathname) }))] });
    const result = await GET("admin/setting/users/profile");
    if (result?.status) {
      localStorage.setItem("scp-profile", JSON.stringify(result.data));
      this.setState({
        user_profile: result.data,
        array_link: [{ name: "หน้าหลัก", link: "/dashboard", show: false, menu: [] },...this.filterMenu(result.data).map((e) => ({ ...e, show: JSON.stringify(e).includes(window.location.pathname) }))],
      });
    }
  };

  filterMenu = (profile) => {
    let permissions = profile?.role?.permission || [];
    permissions.push("status-debtor-reports.read")
    if(profile.user_type === "super_user"){
      permissions.push("history-lists.read")
      permissions.push("debt-reduces.read")
      permissions.push("deposit-lists.read")
      permissions.push("payment-lists.read")
      permissions.push("update-cost.read")
      permissions.push("sales.read")
      permissions.push("receive-goods.read")
      // permissions.push("dialy-debtors-reports.read")
    }

    const filteredMenu = global.menu
      .map((item) => {
        // ตรวจสอบสิทธิ์เมนูหลัก
        const hasMainPermission = item.link === "" || permissions.includes(item.link.split("/").pop() + ".read");
        // ตรวจสอบสิทธิ์เมนูย่อย (ถ้ามี)
        const filteredSubMenu = (item.menu || []).filter((sub) => permissions.includes(sub.link.split("/").pop() + ".read"));

        // แสดงเฉพาะเมนูที่:
        // - มีสิทธิ์ดูเมนูหลัก
        // - หรือ มีเมนูย่อยที่ผ่านสิทธิ์
        if (hasMainPermission || filteredSubMenu.length > 0) {
          return {
            ...item,
            menu: filteredSubMenu,
          };
        }

        return null; // ไม่แสดงเมนูนี้เลย
      })
      .filter(Boolean); // ลบค่า null ออก
    return filteredMenu;
  };

  componentDidUpdate() {
    const active = document.querySelector(".active");
    if (active) {
      active.focus();
      active.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  componentMenu = () => {
    return (
      <div>
        <div className="w-100 text-center">
          <img alt="logo" src={LOGO} height={130} style={{ objectFit: "contain" }} />
          <br />
          <small>v {process.env.REACT_APP_VERSION}</small>
        </div>
        {this.state.array_link.map((item, index) => (
          <>
            {item.link ? (
              <a href={item.link} className={`btn btn-outline-light text-dark border-0 rounded-0 w-100 text-start d-flex align-items-center justify-content-start p-1 px-4 py-2 ${item.link === window.location.pathname ? "active" : ""}`}>
                {item.name}
              </a>
            ) : (
              <div>
                <button
                  className="btn btn-outline-light text-dark border-0 rounded-0 w-100 text-start d-flex align-items-center justify-content-start p-1 px-4 py-2 d-flex justify-content-between"
                  onClick={() => {
                    let array_link = this.state.array_link;
                    array_link[index].show = !array_link[index].show;
                    this.setState({ array_link: array_link });
                  }}
                >
                  {item.name}
                  <span className="icon text-12">{item.show ? "\uf077" : "\uf078"}</span>
                </button>
                <div className={`ps-4 menu-${item.show ? "show" : "hidden"}`}>
                  {item.menu.map((sub_item, sub_index) => (
                    <a key={`id-${sub_index}`} href={sub_item.link} className={`btn btn-outline-light text-dark border-0 rounded-0 w-100 text-start d-flex align-items-center justify-content-start p-1 px-4 py-2 ${sub_item.link === window.location.pathname ? "active" : ""}`}>
                      {sub_item.name}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </>
        ))}
        <button
          className="btn btn-outline-light border-0 rounded-0 w-100 text-start d-flex align-items-center justify-content-start p-1 mb-2 text-danger px-4 py-2"
          onClick={async () => {
            if (await alert("", "warning", "ยืนยัน", "ต้องการออกจากระบบหรือไม่", "ออกจากระบบ", "ยกเลิก")) {
              localStorage.clear();
              window.location.href = "/";
            }
          }}
        >
          Logout
        </button>
      </div>
    );
  };
  render() {
    const { user_profile, dropdown, array_link } = this.state;
    return (
      <div className="hpx-50">
        <div className="body pt-0">
          <Navbar className="bg-primary" style={{ zIndex: 1000 }} expand="xl">
            <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="overflow-auto">
              <Nav className="ms-auto">
                <div className="d-none d-xl-flex align-items-center px-3">
                  <span className="icon text-dark me-1 wpx-30 hpx-30 rounded-circle bg-white d-flex align-items-center justify-content-center">{"\uf007"}</span>
                  <div className="px-2">
                    <div className="text-14 text-white">{user_profile?.full_name || "Username"}</div>
                    <div className="text-12 text-white" style={{ marginTop: -2 }}>
                      {user_profile?.user_type.replaceAll("_", "")}
                    </div>
                  </div>
                </div>
                <div className="d-block d-xl-none mb-5 pt-4 bg-white" style={{ height: "auto" }}>
                  {this.componentMenu()}
                </div>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
        <div className="position-fixed wpx-260 bg-white py-3 overflow-scroll d-none d-xl-block position-fixed bg-light" style={{ zIndex: 1, height: "100vh", top: 0 }}>
          {this.componentMenu()}
        </div>
      </div>
    );
  }
}
